import isBotFast from 'isbot-fast';

function withCtxIsBot() {
  return async ctx => {
    try {
      // assert isBot on server user agent header or client userAgent
      // eslint-disable-next-line no-undef
      ctx.data.isBot = isBotFast(ctx.req ? ctx.req.headers['user-agent'] : navigator.userAgent);
    } catch (err) {
      // if there is an error asserting the bot then we default to false
      ctx.data.isBot = false;
    }
    ctx.registerMiddleware('is-bot');
  };
}

export { withCtxIsBot };
